import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Resets scroll to the top of the document on every PUSH/REPLACE navigation.
// - behavior: 'instant' overrides the global `html { scroll-behavior: smooth }`
//   set in index.css / styles/globals.css. Without this, route changes
//   animate from the previous page's scroll position to 0 over ~500ms,
//   which reads as "the new page loaded scrolled down".
// - POP navigations (browser back/forward) are skipped so the browser's
//   native scroll restoration can return the user to where they were.
// - URLs with a hash (e.g. /faq#shipping) are skipped so the in-page
//   anchor scroll can land correctly.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, navigationType]);

  return null;
}
